import { defaultAuroraProviderConfiguration } from 'src/features/on-chain/calculation-manager/providers/dexes/aurora/default-constants';

export const WANNA_SWAP_AURORA_CONTRACT_ADDRESS = '0xa3a1eF5Ae6561572023363862e238aFA84C72ef5';

export const WANNA_SWAP_AURORA_PROVIDER_CONFIGURATION = defaultAuroraProviderConfiguration;
